<script setup lang="ts">
withDefaults(defineProps<{ size?: 's' | 'm'; loading?: boolean }>(), { size: 'm' });

const store = useDurationFilterStore();
</script>

<template>
  <div
    v-if="loading"
    class="flex flex-col gap-4"
  >
    <UiSkeleton class="h-9 w-full rounded-md" />
    <div class="flex flex-col gap-2">
      <UiSkeleton class="h-2 w-32 rounded-full" />
      <UiSkeleton class="h-4 w-full rounded-full" />
      <div class="flex justify-between">
        <UiSkeleton class="ml-auto h-2 w-12" />
      </div>
    </div>
  </div>
  <ResultsFiltersLegTabsWrapper v-else>
    <template #departure>
      <UiCustomFilterLabeledSlider
        v-model="store.legs[0].durationValue"
        :size="size"
        :min="1"
        :max="24"
        :step="1"
        :title="$t('components.results.filters.durationTitle')"
      >
        <template #labels="{ end }">
          <span class="grow text-right">{{ end }}h</span>
        </template>
      </UiCustomFilterLabeledSlider>
    </template>
    <template #return>
      <UiCustomFilterLabeledSlider
        v-model="store.legs[1].durationValue"
        :size="size"
        :min="1"
        :max="24"
        :step="1"
        :title="$t('components.results.filters.durationTitle')"
      >
        <template #labels="{ end }">
          <span class="grow text-right">{{ end }}h</span>
        </template>
      </UiCustomFilterLabeledSlider>
    </template>
  </ResultsFiltersLegTabsWrapper>
</template>
